import BaseFormController from "../../validation/BaseFormController";
import {FormField, OptionalFormField} from "../../validation/FormField";
import {none, option} from "ts-option";
import PartnerBrandBankData from "../../model/partnerBrand/PartnerBrandBankData";
import FormValidation from "../../validation/FormValidation";
import {ValidationResult} from "../../validation/ValidationResult";

const uuidv4 = require("uuid/v4");

/**
 * Partner brand bank data form.
 */
export default class PartnerBrandBankDataForm extends BaseFormController<PartnerBrandBankDataForm> {
	constructor(formId: string,
		public readonly bankAccountNumber: OptionalFormField<string>,
		public readonly bankSortCode: OptionalFormField<string>,
		public readonly accountHolder: OptionalFormField<string>) {
		super(bankAccountNumber, formId);
	}

	static createPartnerBrandBankDataForm({
		bankAccountNumber = none,
		bankSortCode = none,
		accountHolder = none
	}) {
		return new PartnerBrandBankDataForm(
			uuidv4(),
			OptionalFormField.create<string>(bankAccountNumber),
			OptionalFormField.create<string>(bankSortCode),
			OptionalFormField.create<string>(accountHolder)
		);
	}

	public static createEmpty(): PartnerBrandBankDataForm {
		return this.createPartnerBrandBankDataForm({});
	}

	static createFromPartnerBrandBankData(partnerBrandBankData: PartnerBrandBankData) {
		return PartnerBrandBankDataForm.createPartnerBrandBankDataForm({
			bankAccountNumber: option(partnerBrandBankData.bankAccountNumber),
			bankSortCode: option(partnerBrandBankData.bankSortCode),
			accountHolder: partnerBrandBankData.accountHolder
		});
	}

	validate(): PartnerBrandBankDataForm {
		return FormValidation.validateForm<PartnerBrandBankDataForm>(this, (form, config) => form.copy(config));
	}

	onValid(onValid: (partnerBrandBankData: PartnerBrandBankData) => void): ValidationResult<PartnerBrandBankData> {
		return FormValidation.validateFields([this.bankAccountNumber, this.bankSortCode],
			() =>
				new PartnerBrandBankData(
					uuidv4(),
					this.bankAccountNumber.getValue().getOrElse(""),
					this.bankSortCode.getValue().getOrElse(""),
					this.accountHolder.getValue()
				)
		).onSuccess(partnerBrandBankData => onValid(partnerBrandBankData));
	}

	copy({
		bankAccountNumber = this.bankAccountNumber,
		bankSortCode = this.bankSortCode,
		accountHolder = this.accountHolder
	}): PartnerBrandBankDataForm {
		return new PartnerBrandBankDataForm(this.formId, bankAccountNumber, bankSortCode, accountHolder);
	}

	fields(): Array<FormField<any>> {
		return [this.bankAccountNumber, this.bankSortCode, this.accountHolder];
	}
}
